/* Stores */
import { useUserStore } from '@/store/user/user'

import { profileLayoutRoutes } from '@/types/plugins/layout'

import { defineNuxtRouteMiddleware } from '#app'

// Для личного кабинета проверяем авторизацию
export default defineNuxtRouteMiddleware((to) => {
  if (!profileLayoutRoutes.includes(String(to.name))) return

  const userStore = useUserStore()

  if (userStore.isPendingStatistic) {
    return
  }

  userStore.isPendingStatistic = true
  userStore
    .getStatistic()
    .then(() => {
      if (!userStore.isAuthenticated) {
        navigateTo(`/login/?backUrl=${to.path}`)
      }
    })
    .finally(() => {
      userStore.isPendingStatistic = false
    })
})
